export default "/images/8246b02898aced31bf287e074ed8a5cd.png";